/**
 * Feature Flags Service - работа с feature flags
 */
import { api } from '../core/api';

// ============================================================================
// ТИПЫ
// ============================================================================

export interface FeatureFlag {
  id: string;
  key: string;
  name: string;
  description: string | null;
  enabled: boolean;
  metadata: Record<string, unknown>;
  created_at: string;
  updated_at: string;
}

export interface FeatureFlagPublic {
  key: string;
  name: string;
  description: string | null;
  enabled: boolean;
  metadata: Record<string, unknown>;
}

export interface UpdateFeatureFlagData {
  enabled: boolean;
  name?: string;
  description?: string;
  metadata?: Record<string, unknown>;
}

// ============================================================================
// FEATURE FLAGS SERVICE
// ============================================================================

export const featureFlagsService = {
  /**
   * Получить все feature flags (для админки, требует авторизации)
   */
  getAll: () =>
    api.get<FeatureFlag[]>('/admin/feature-flags'),

  /**
   * Получить публичные feature flags (без авторизации, для кеширования)
   */
  getPublic: async (): Promise<FeatureFlagPublic[]> => {
    // Используем fetch напрямую для публичного эндпоинта без авторизации
    const baseUrl = import.meta.env.VITE_API_BASE_URL || '/api';
    const response = await fetch(`${baseUrl}/health/feature-flags`);
    const data = await response.json();
    return data.data || [];
  },

  /**
   * Обновить feature flag (только enabled/description)
   */
  update: (key: string, data: UpdateFeatureFlagData) =>
    api.put<FeatureFlag>(`/admin/feature-flags/${key}`, data),
};


